import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

export const DefaultIcon: FunctionComponent<IIconProps & { opacity?: number }> = ({
  opacity,
  ...props
}) => (
  <Icon {...{ viewBox: '0 0 21 20', ...props }} fill="none">
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#F3FAFB"
      d="M10.5 1.666H3a1.667 1.667 0 0 0-1.667 1.667v13.333A1.667 1.667 0 0 0 3 18.333h10a1.667 1.667 0 0 0 1.667-1.667V5.833L10.5 1.666Z"
    />
    <Path fill="#CDE9EF" d="M9.667 1.666v3.333a1.667 1.667 0 0 0 1.667 1.667h3.333" />

    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="none"
      stroke="#5AB8CA"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.667 1.666v3.333a1.667 1.667 0 0 0 1.667 1.667h3.333m-4.167-5H3a1.667 1.667 0 0 0-1.667 1.667v13.333A1.667 1.667 0 0 0 3 18.333h10a1.667 1.667 0 0 0 1.667-1.667V5.833L10.5 1.666Z"
    />
  </Icon>
)
